import React, { useCallback, useEffect, useRef } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import GooglePay from 'utils/GooglePay';
import LanguageLocale from 'utils/LanguageLocale';

import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';

import { buttons } from 'style/config';

const GooglePayButton = ({ isGooglePayPayment, transactionAmount, css, ...rest }) => {
    const containerRef = useRef(null);

    const handleClick = useCallback(async () => {
        processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
            data: {
                linkName: 'basket:payment:googlepay',
                actionInfo: 'basket:payment:googlepay',
                eventStrings: [anaConsts.Event.EVENT_71]
            }
        });

        try {
            const result = await GooglePay.startCheckout({
                transactionAmount,
                transactionCurrencyCode: LanguageLocale.getCountryISOCurrency()
            });
            Sephora.logger.info('[GooglePay] paymentData received', result);
        } catch (err) {
            Sephora.logger.info('[GooglePay] startCheckout rejected', err);
        }
    }, [transactionAmount]);

    useEffect(() => {
        if (isGooglePayPayment === GooglePay.TYPES.HIDDEN || !containerRef.current) {
            return undefined;
        }

        let buttonNode;

        try {
            buttonNode = GooglePay.getPaymentsClient().createButton({
                onClick: handleClick,
                buttonType: 'plain',
                buttonColor: 'black',
                buttonSizeMode: 'fill',
                buttonRadius: buttons.HEIGHT / 2
            });
            containerRef.current.appendChild(buttonNode);
        } catch (err) {
            Sephora.logger.error('[GooglePay] createButton failed', err);
        }

        return () => {
            if (buttonNode && buttonNode.parentNode === containerRef.current) {
                containerRef.current.removeChild(buttonNode);
            }
        };
    }, [isGooglePayPayment, handleClick]);

    if (isGooglePayPayment === GooglePay.TYPES.HIDDEN) {
        return null;
    }

    return (
        <div
            ref={containerRef}
            data-at={Sephora.debug.dataAt('basket_googlepay_btn')}
            css={[containerStyle, css]}
            {...rest}
        />
    );
};

const containerStyle = {
    display: 'flex',
    width: '100%',
    height: buttons.HEIGHT,
    '& .gpay-button-fill': {
        width: '100%',
        height: buttons.HEIGHT,
        minHeight: buttons.HEIGHT
    }
};

export default wrapFunctionalComponent(GooglePayButton, 'GooglePayButton');
